import styled from 'styled-components';
import React, { FC } from 'react';
import { NoticeProps } from 'react-select/src/components/Menu';
import { OptionTypeBase } from 'react-select';
import { globalTheme, useMixin } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { Icon } from '@cld/icon';

const Root = styled.div`
  ${typography.xs.regular};
  padding: ${globalTheme.spacing.xs};
  ${Icon} {
    margin-right: ${globalTheme.spacing.xxs};
  }
`;

export const NoOptionsMessage: FC<NoticeProps<OptionTypeBase>> = (props) => {
  const color = useMixin(globalTheme.palette.errorAlt);
  return (
    <Root>
      <Icon size="md" name="error" color={color} />
      {props.selectProps.noOptionsMessage?.({ inputValue: props.selectProps.inputValue || '' })}
    </Root>
  );
};
